import { useSelector } from 'react-redux';

import type { ReduxState } from 'app/redux/types';

import { useTranslation } from 'app/lang';
import { selectIsLoggedIn } from 'app/redux/selectors/auth';

import { DISABLED_TITLE_STATUSES } from '../constants';
import { selectSingleBetsInfo } from '../selectors/stakeTypes/single';

const usePledgeStakesTitle = (
  betId: number,
) => {
  const { t } = useTranslation();
  const betInfo = useSelector((state: ReduxState) => selectSingleBetsInfo(state).get(betId));
  const isLoggedIn = useSelector(selectIsLoggedIn);

  const maxValue = betInfo?.limits.max || 0;
  const paymentOptions = betInfo?.paymentOptions;
  const { noAuth, noChainAvailable } = DISABLED_TITLE_STATUSES;

  if (!isLoggedIn) {
    return t(noAuth);
  }

  if (!(paymentOptions?.isPledgePossible && maxValue > 0)) {
    return t(noChainAvailable);
  }
};

export default usePledgeStakesTitle;
